import React from "react";

import { Grid } from "@mui/material";
import classnames from "classnames";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { FiVideo, FiCalendar, FiClock } from "react-icons/fi";
import { Link } from "react-router-dom";

import Button, { Color } from "../../../../../components/Form/Button";
import Modal from "../../../../../components/Generic/Modal";
import { PRIVATE_ROUTES } from "../../../../../constants";
import { Task } from "../../../../../models/task";
import useStyles from "./styles";

interface Props {
  tasks?: Task[];
  handleClose: () => void;
  open: boolean;
}

const SelectSurveyTaskModal = (props: Props) => {
  const { tasks, handleClose, open } = props;

  const { t: translate } = useTranslation();

  const classes = useStyles();

  const renderRowLineTask = (index: number) => {
    if (tasks?.length !== index + 1) return <hr className={classes.line} />;

    return null;
  };

  const renderTasks = () => {
    return tasks?.map((task, index) => {
      if (task?.startDate) {
        return (
          <React.Fragment key={`video-survey-${index}`}>
            <Grid container item direction="row" alignItems="center" justifyContent="space-between">
              <div className={classes.flexColumn}>
                <span className={classes.title}>
                  {task?.type} {tasks.length > 1 ? `(${index + 1})` : ""}
                </span>
                <div className={classnames(classes.flexRow, classes.columnInfo)}>
                  <div className={classnames(classes.flexRow, classes.dateRow)}>
                    <FiCalendar color="#667085" size={18} className={classes.icon} />
                    <span className={classes.description}>
                      {format(new Date(task.startDate), "dd/MM")}
                    </span>
                  </div>
                  <div className={classes.flexRow}>
                    <FiClock color="#667085" size={18} className={classes.icon} />
                    <span className={classes.description}>
                      {format(new Date(task.startDate), "hh:mmaaa")}
                    </span>
                  </div>
                </div>
              </div>
              <div className={classes.flexColumnCenter}>
                <Link
                  target="_blank"
                  to={{ pathname: `${PRIVATE_ROUTES.VIDEOCALL}/${task.id}` }}
                  className={classes.button}
                >
                  <Button
                    startIcon={<FiVideo color="#FFFFFF" />}
                    customColor={Color.SECONDARY}
                    className={classes.button}
                    onClick={() => handleClose()}
                  >
                    {translate("openVideoSurvey")}
                  </Button>
                </Link>
              </div>
            </Grid>
            {renderRowLineTask(index)}
          </React.Fragment>
        );
      }

      return null;
    });
  };

  return (
    <Modal
      title={translate("selectAVideoSurveyOfToday")}
      open={open}
      handleClose={handleClose}
      className={classes.modal}
    >
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        className={classes.mainGrid}
      >
        {renderTasks()}
      </Grid>
    </Modal>
  );
};

export default SelectSurveyTaskModal;
